import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Dubblett av /elnat – pekas om permanent till elnätsbolagslistan. */
export const Route = createFileRoute("/elbolag/elnat/")({
  beforeLoad: () => permanentRedirect("/elnat"),
});
